import React from 'react'
import PropTypes from 'prop-types'

import useSaleCart from '../helpers/use_sale_cart'
import CartLoader from './cart_loader'
import Cart from './cart'
import { Button } from 'lensrentals-components'

const SaleCart = props => {
  const [saleCart, updateSaleCart] = useSaleCart()

  const {
    loading,
    updating,
    plan: salePlan
  } = saleCart

  let error = {
    message: saleCart.error,
    button: 'default'
  }

  const removeProblematicItems = () => {
    const fixedCartObject = { ...salePlan.cartObject }
    salePlan.cart.forEach(item => {
      if (Object.keys(item.saleListing).length === 1) {
        delete fixedCartObject[item.saleListing.id]
      }
    })
    updateSaleCart(salePlan.withItemsUpdated(fixedCartObject))
  }

  salePlan?.cart.forEach(item => {
    // if for some reason we ask backend about a malformed sale_product_id
    // it will return ONLY { saleListing: { id: 'abc123' } }
    // if the ANY saleListing object only contains one key, we know we got this error
    if (Object.keys(item.saleListing).length === 1) {
      error = {
        message: 'Uh oh, something went wrong on our end with some of your items.',
        button: <Button color='danger' onClick={removeProblematicItems}>Remove problematic items?</Button>
      }
    }
  })

  return (
    <CartLoader
      loading={loading}
      error={error}
    >
      {
        (props.isActive && !(loading || error.message))
          ? <Cart
              cartPlan={salePlan}
              updateCartPlan={updateSaleCart}
              updating={updating}
            />
          : ''
      }
    </CartLoader>
  )
}

SaleCart.propTypes = {
  isActive: PropTypes.bool.isRequired
}

export default SaleCart
